var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1114_3081)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "url(#paint0_linear_1114_3081)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 16.3616C10.0683 14.3288 11.034 12.3838 12.9385 10.9182C13.4923 10.486 14.1069 10.7427 14.3095 11.1749C14.4851 11.5396 14.3838 11.9583 14.0731 12.2284C13.7355 12.5121 13.3843 12.789 13.0939 13.1199C10.8787 15.6458 11.419 19.5291 14.2285 21.3661C17.558 23.5407 22.0626 21.5754 22.6772 17.6516C23.0217 15.4432 22.245 13.6467 20.4823 12.2757C20.1716 12.0326 20.0366 11.6882 20.1311 11.3437C20.2189 10.9993 20.5093 10.7494 20.8808 10.7089C21.1104 10.6819 21.313 10.7494 21.4953 10.8845C23.0149 12.0123 23.9942 13.4914 24.3454 15.3554C24.9397 18.4755 23.5687 21.4539 20.8267 23.0477C19.5773 23.7703 18.2131 24.1013 16.7678 23.9729C13.8165 23.7096 11.7499 22.1968 10.5478 19.5021C10.1628 18.6444 9.98722 17.6313 10.0007 16.3616Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0985 12.7077C18.0985 13.6532 18.0985 14.592 18.0985 15.5375C18.0985 15.9292 17.8554 16.2466 17.4907 16.3547C17.126 16.4627 16.7343 16.3276 16.5317 16.0035C16.4506 15.8684 16.3898 15.6928 16.3898 15.5375C16.3831 13.6532 16.3831 11.769 16.3898 9.88472C16.3898 9.3782 16.768 9 17.2543 9C17.7405 9.00675 18.1052 9.38495 18.1052 9.89823C18.0985 10.837 18.0985 11.769 18.0985 12.7077Z",
    fill: "#303030"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1114_3081",
    x: -30,
    y: -30,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1114_3081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1114_3081",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1114_3081",
    x1: 2.26667,
    y1: 2.26667,
    x2: 51.0398,
    y2: 64.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.60abbabb413095111599ac64e9767670.svg";
export { ForwardRef as ReactComponent };